import api from './axios';

// 登录
const login = (data) => {
  return api.post('/auth/login', data);
};

// 登出
const logout = () => {
  return api.post('/auth/logout');
};

// 当前登录用户
const me = () => {
  return api.get('/auth/me');
};

// 获取验证码
const getCaptcha = () => {
  return api.get('/auth/captcha');
};

// 忘记密码
const forgotPassword = (data) => {
  return api.post('/auth/forgot-password', data);
};

// 重置密码
const resetPassword = (data) => {
  return api.post('/auth/reset-password', data);
};

export default {
  login,
  logout,
  me,
  getCaptcha,
  forgotPassword,
  resetPassword
};
